import { Ai as AiIcon, Close as CloseIcon } from '@mint-lib/icons';
import { Button, typographyVariants } from '@mint-lib/tw-components';

import { useAiSidebarContext } from '../../../context.jsx';

type SidebarHeaderProps = {
  isWithSidebar: boolean;
};

const SidebarHeader = ({ isWithSidebar }: SidebarHeaderProps) => {
  const { setIsAiSidebarOpen } = useAiSidebarContext();

  return (
    <div
      className={`${isWithSidebar ? 'mb-6' : 'mb-3'} sticky top-0 z-focus flex items-center bg-ui-primary px-2 py-2 pb-3`}
    >
      <Button
        variant="plain"
        icon
        size="large"
        onClick={() => setIsAiSidebarOpen(false)}
      >
        <CloseIcon />
      </Button>
      <div className="mx-auto flex flex-row items-center justify-center gap-2">
        <p
          className={typographyVariants({
            variant: 'h4',
            color: 'primary',
          })}
        >
          MINT
        </p>
        <AiIcon className="h-5 w-5" />
      </div>
    </div>
  );
};

export default SidebarHeader;
